{
  "title": "支付",
  "subtitle": "完成您的商标注册付款",
  "summary": {
    "title": "订单摘要",
    "countries": "已选国家",
    "classes": "尼斯分类",
    "subtotal": "小计",
    "governmentFees": "政府费用",
    "serviceFee": "服务费",
    "total": "总计",
    "taxNote": "价格包含适用税费"
  },
  "methods": {
    "title": "支付方式",
    "card": "信用卡/借记卡",
    "cardNumber": "卡号",
    "expiry": "有效期",
    "cvc": "安全码",
    "nameOnCard": "持卡人姓名",
    "secure": "安全支付",
    "stripeTitle": "Stripe安全结账",
    "stripeDesc": "您的付款通过Stripe安全处理。我们从不存储您的信用卡信息。",
    "ssl": "256位SSL加密",
    "pci": "符合PCI DSS标准",
    "cards": "接受所有主流信用卡"
  },
  "status": {
    "processing": "正在处理支付...",
    "success": "支付成功！",
    "failed": "支付失败",
    "tryAgain": "请重试或使用其他支付方式。",
    "pending": "支付待处理",
    "refunded": "已退款"
  },
  "confirmation": {
    "title": "支付已确认",
    "thankYou": "感谢您的付款！",
    "receiptSent": "收据已发送至{{email}}",
    "nextSteps": "后续步骤",
    "applicationSubmitted": "您的商标申请已提交处理。",
    "viewStatus": "查看申请状态",
    "downloadReceipt": "下载收据"
  },
  "buttons": {
    "pay": "支付{{amount}}",
    "payNow": "立即支付",
    "reviewOrder": "查看订单",
    "proceedToPayment": "前往支付",
    "payAmount": "支付${{amount}} - 前往安全结账",
    "agreeTerms": "我同意",
    "terms": "服务条款",
    "and": "和",
    "privacy": "隐私政策"
  }
}
